import { createFoundationController } from '@othercommerce/foundation';
import { createViewResolver } from '@storefront/views';
import { createStorefront } from './app';
import { ServiceWorkerRegistrationInjectionKey } from '@storefront/storefront';
import AppServiceWorker from './worker.ts?worker&url';
import { ref, type Ref } from 'vue';
import * as Sentry from '@sentry/vue';

const serviceWorkerRegistration = ref() as Ref<ServiceWorkerRegistration | undefined>;

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register(AppServiceWorker).then((registration) => {
      serviceWorkerRegistration.value = registration;
      registration.update();
    }).catch((error) => {
      console.error('Service worker registration failed:', error);
    });
  });
}

// noinspection JSIgnoredPromiseFromCall
createFoundationController({
  resolver: createViewResolver,
  setup: (options) => {
    const app = createStorefront(options);

    Sentry.init({
      app,
      dsn: options.props.state.shared.appSentryDsn || undefined,
      allowUrls: [
        options.props.state.shared.appUrl
      ]
    });

    app.provide(ServiceWorkerRegistrationInjectionKey, serviceWorkerRegistration);
    app.mount('#app');

    return app;
  },
});
